import React from "react";

/**
 * Flatch brand mark — two coral slanted parallelograms forming a stylized "F".
 * Uses `currentColor` for the fill so parents can theme it via text color.
 * Default color: brand coral (#E85D5D) via the wrapper class.
 */
export function FlatchLogo({ className = "", strokeColor, ...rest }) {
    return (
        <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="Flatch"
            {...rest}
        >
            <g fill="currentColor">
                {/* Top bar — wider parallelogram */}
                <rect x="18" y="14" width="72" height="22" rx="4" transform="skewX(15)" />
                {/* Bottom bar — narrower, shifted left */}
                <rect x="8" y="52" width="52" height="22" rx="4" transform="skewX(15)" />
            </g>
        </svg>
    );
}

/**
 * FlatchMark — the logo tile you use in headers.
 * Renders the SVG inside a rounded coral tile (like the reference logo card).
 */
export function FlatchMark({ size = 40, tone = "coral", className = "" }) {
    // tone: "coral" | "purple" | "ghost"
    const bg =
        tone === "coral"
            ? "#FDECEC"
            : tone === "purple"
              ? "rgb(var(--accent))"
              : "transparent";
    const fg =
        tone === "coral"
            ? "#E85D5D"
            : tone === "purple"
              ? "rgb(var(--primary))"
              : "currentColor";
    return (
        <div
            className={`inline-flex items-center justify-center rounded-2xl ${className}`}
            style={{ width: size, height: size, background: bg }}
            aria-hidden
        >
            <FlatchLogo style={{ width: "70%", height: "70%", color: fg }} />
        </div>
    );
}

/**
 * FlatchWordmark — mark + "Flatch" text side by side.
 * Sizes tuned for the app header.
 */
export function FlatchWordmark({ size = 40, tone = "coral", textClassName = "" }) {
    return (
        <div className="inline-flex items-center gap-2">
            <FlatchMark size={size} tone={tone} />
            <span className={`font-display text-xl font-black tracking-tight ${textClassName}`}>Flatch</span>
        </div>
    );
}
